module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hyxy-dialog-wrap"
  }, [_c('CvipDialog', {
    attrs: {
      "title": _vm.title,
      "btnTxt": _vm.btnTxt,
      "stopPrevent": _vm.stopPrevent
    },
    on: {
      "btnClick": function($event) {
        return _vm.close()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('div', {
    staticClass: "hyxy-agreement"
  }, [_c('div', {
    staticClass: "hyxy-content"
  }, [_c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("欢迎您使用58招聘求职金卡服务。")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("《58招聘求职金卡服务协议》是您在使用58招聘求职金卡服务时必须遵守的协议（以下简称“本协议”）。您勾选同意或实际接受了58（指58同城（www.58.com）的网络服务提供者，包括58同城网（www.58.com）的所有者及其关联服务提供方）招聘求职金卡服务，就表示您已接受了本协议的全部约定并愿意受其约束。"), _c('b', {
    staticClass: "blod"
  }, [_vm._v("请您仔细阅读本协议，充分理解本协议的各条款内容。如果您不同意本规则或其中任何条款约定，应立即停止使用58求职金卡服务。如发生纠纷，您不能以未经仔细阅读为由进行抗辩。甲方除应遵守本协议约定外，还应遵守58同城线上《58同城使用协议》（http://about.58.com/home/announcement.html）、《58推广用户服务协议》（http://tuiguang.58.com/agreement）、《58同城隐私权条款》（http://about.58.com/395.html）的相关规定。")])])]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-content"
  }, [_c('div', {
    staticClass: "hyxy-title"
  }, [_vm._v("一、招聘求职金卡服务的内容")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("1、您首先应该清楚地了解58招聘求职金卡服务的业务模式。您购买招聘求职金卡服务套餐后即成为58同城的黄金会员用户。在招聘求职金卡套餐有效期内，您将根据所购买套餐的类型享有以下几项或全部求职特权，包括应聘优先、简历置顶、投递特权、免费刷新、黄金亮点、竞争力分析、面试无忧、尊贵标识、专属客服等，具体以58同城平台公示为准。")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("2、您可通过在线支付或用您在58同城开立的交易宝账户、58现金账户（具体以58同城平台公示的为准）内的余额购买招聘求职金卡服务套餐。"), _c('b', {
    staticClass: "blod"
  }, [_vm._v("您知悉并同意，因“58招聘求职金卡服务”为在线即时服务产品，一经购买开通，非法定情形，您不得擅自要求提前终止服务，否则，您前期已支付的服务费用将被扣除作为违约金以及对58同城已做工作的补偿。")])])]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-content"
  }, [_c('div', {
    staticClass: "hyxy-title"
  }, [_c('b', {
    staticClass: "blod"
  }, [_vm._v("二、面试无忧专有条款")])]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("您在购买招聘求职金卡服务套餐时可获得58同城额外提供的面试无忧服务，即当您在58同城创建简历且投递简历后5-30天内（具体以申请页面提示为准）包括但不限于通过短信、电话、微聊消息、站内信等方式收到来自招聘单位的面试邀约的，您可以获得赔偿。具体赔偿判别的依据及申请的流程还以下述约定的为准。")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("1. 赔偿判别依据")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("当您符合以下所有条件时，将获得按照本条款第2项所述的标准的赔偿。")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("（1）您购买求职金卡且截至申请赔付时，您发布的简历状态需保持一直为“公开”；")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("（2）您购买求职金卡且截至申请赔付时，您在58平台的求职状态显示为“求职中”；")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("（3）在招聘求职金卡服务有效期内"), _c('b', {
    staticClass: "blod"
  }, [_vm._v("必需要使用完毕会员金卡提供的所有求职的特权功能（如投递简历、刷新简历、置顶简历、微聊特权等功能，具体以58同城届时展示的功能为准）；")])]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("（4）在招聘求职金卡服务有效期内首次投递简历时起算，在5-30个自然日内您未收到过企业的任何面试邀请、电话或微聊信息；")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("（5）同一用户（包括但不限于同一ID会员、同一身份证、同一账户、同一IP、同一手机或同一电脑操作均视为同一用户）只能申请赔付1次，即无论您申请赔付的结果是被拒绝赔付还是同意赔付。鉴于此，58同城提示您，在申请赔付前需详细认真的阅读本协议，以防您申请的结果不符合赔付要求。")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("（6）在58平台完成“我的认证”-“个人认证”-"), _c('b', {
    staticClass: "blod"
  }, [_vm._v("“人脸认证”")]), _vm._v("里完成实名认证且简历名字需与认证通过的身份证姓名一致；")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("（7）所购买的会员卡有效期内投递30个不同的真实企业（具体判定标准以58同城认定的为准）的岗位；")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("（8）简历完整度"), _c('b', {
    staticClass: "blod"
  }, [_vm._v("（以平台显示的完整度为准）")]), _vm._v("需达到90%以上；")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("（9）国家法定节假日提交的赔付申请，58同城将在节假日后的工作日进行处理；")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_c('b', {
    staticClass: "blod"
  }, [_vm._v("（10）以上符合条件的用户会进入人工复核，若经人工核验发现用户存在虚假求职（1、包括但不限于学历、薪资或职位类别等信息与招聘方或一般公众理解的要求相差较多；2、涉嫌虚假求职；3、涉嫌通过黑产等非法利益链条而使用求职金卡；4、未使用金卡权益，非常规工作日时间内投递等；5、涉嫌诈骗嫌疑（最终判定的标准以58同城为准），基于58同城已经在平安投保平台责任险，58同城会连同平安保险公司拉黑处理；")])]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("2. 申请流程")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("（1）当您满足本条款第1项的赔付条件时，需在招聘求职金卡有效期内，在线点击“申请赔付”，由58同城判别您是否符合上述赔付条件，如逾期点击“申请赔付”的，58同城将不再提供此求职保障服务；")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("（2）如经判别符合，您需要按照58同城的要求如实提供信息资料（包括但不限姓名、身份证号、手机号、银行卡信息等），因您填写的信息有误或不真实，导致您未收到赔付款项的，58同城不承担任何责任。如经判别不符合的，您将无法获得赔偿。因判别是否符合出现争议的，最终以58同城判别的为准。")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("（3）赔付金额具体以58招聘求职金卡服务套餐购买页面会员特权介绍中展示的为准。")]), _vm._v(" "), _c('table', {
    staticClass: "hyxy-table"
  }, [_c('tr', [_c('td'), _vm._v(" "), _vm._l((_vm.hyxyMealInfo), function(mealName) {
    return _c('td', [_vm._v(_vm._s(mealName.name))])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("卡面价值（元）")]), _vm._v(" "), _vm._l((_vm.hyxyMealInfo), function(mealName) {
    return _c('td', [_vm._v(_vm._s(mealName.price))])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("赔偿金额（元）")]), _vm._v(" "), _vm._l((_vm.hyxyMealInfo), function(mealName) {
    return _c('td', [_vm._v(_vm._s(mealName.compensate))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("（4）平安偿付能力数据和综合评级结果的链接：")]), _vm._v(" "), _c('a', {
    staticClass: "hyxy-link-pingan",
    attrs: {
      "href": "http://property.pingan.com/gongkaixinxipilu/changfunenglixinxipilubaogao.shtml",
      "target": "_blank"
    }
  }, [_vm._v("http://property.pingan.com/gongkaixinxipilu/changfunenglixinxipilubaogao.shtml")])]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-content"
  }, [_c('div', {
    staticClass: "hyxy-title"
  }, [_vm._v("三、招聘求职金卡服务规则")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("1、您应按照58同城页面显示信息字段填写或完善您的求职意向信息，且保证所填写的信息真实、有效、合法、不得 冒用、盗用、仿造、变造。如因您提供的信息不符合上述要求，58同城有权拒绝为您提供招聘求职金卡服务。")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_c('b', {
    staticClass: "blod"
  }, [_vm._v("2、您知悉并确认58同城提供的招聘求职金卡服务中的竞争力分析服务，仅为您的求职过程中提供参考，58同城在任何情况下并不对竞争力分析结果的真实性、准确性、有效性、客观性或相应的任何后果（包括但不限于您依据分析结果、资料或服务而做出的决定或者采取的行动等）承担任何责任。")])]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_c('b', {
    staticClass: "blod"
  }, [_vm._v("3、您知悉并授权58同城有权通过您填写的简历信息请第三方认证机构核实您的身份信息以便完成您的“个人认证”服务。")])]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("4、您知悉58同城仅对您填写的信息进行形式审核，如服务开通后经由第三方（包括但不限于与您有交易的用户、国家监管机关或司法机关的通知、裁决等）投诉举证您存在资质冒用、伪造等情形 且您也未能及时自证的，58同城有权冻结您的账号及至终止提供服务并要求您向58同城承担违约责任。")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_c('b', {
    staticClass: "blod"
  }, [_vm._v("5、您知悉58同城仅为互联网信息发布平台，推荐给您的招聘信息来源于58同城网站上推广用户自行发布的招聘信息。58同城不对推荐给您的招聘单位的信息的真实、合法性承担任何责任也不对推荐的行为做效果承诺，您应自行谨慎选择招聘单位，最终是否录用以您自行与招聘单位进行沟通确认的为准。如您与招聘单位发生纠纷，您需与招聘单位自行协商解决，58同城不承担任何责任。")])])]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-content"
  }, [_c('div', {
    staticClass: "hyxy-title"
  }, [_vm._v("四、其他")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_c('b', {
    staticClass: "blod"
  }, [_vm._v("1、58同城有权根据国家法律法规的更新、产品和服务规则的调整需要不时地制订、修改本协议涉及的招聘求职金卡服务及求职保障服务，并以网站公示的方式进行公示。如您继续使用58同城招聘求职金卡服务的，即表示您接受经修订的规则和条款。如发生有关争议时，以最新的58招聘求职金卡服务协议为准。")])]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("2、"), _c('b', {
    staticClass: "blod"
  }, [_vm._v("本规则采用电子文本形式制成")]), _vm._v("，由用户通过58同城平台签署并永久保存在58同城为此设立的专用服务器上备查，同时，双方均认可该形式的规则效力。")]), _vm._v(" "), _c('div', {
    staticClass: "hyxy-text"
  }, [_vm._v("3、本规则的订立、执行、解释及争议解决均适用中华人民共和国法律。因本规则的履行或本规则引起的任何争议双方应通过友好协商方式解决，如无法通过友好协商方式解决的，双方一致同意通过"), _c('b', {
    staticClass: "blod"
  }, [_vm._v("北京市朝阳区人民法院")]), _vm._v("以诉讼方式解决。")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe5c6816"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/modules/dialog/HyxyDialog.vue
// module id = jDRM
// module chunks = 1